var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPathFigmaLog(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2648_2425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.863 120.001C50.823 120.001 59.7182 111.041 59.7182 100V80.0005H39.863C28.9029 80.0005 20.0078 88.9605 20.0078 100C20.0078 111.041 28.9029 120.001 39.863 120.001Z",
    fill: "#24CE85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0078 59.9995C20.0078 48.9595 28.9029 39.9995 39.863 39.9995H59.7182V79.9995H39.863C28.9029 79.9995 20.0078 71.0395 20.0078 59.9995Z",
    fill: "#A160FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0117 20C20.0117 8.96 28.9068 0 39.8669 0H59.7221V40H39.8669C28.9068 40 20.0117 31.04 20.0117 20Z",
    fill: "#EF4F2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7178 0H79.573C90.533 0 99.4282 8.96 99.4282 20C99.4282 31.04 90.533 40 79.573 40H59.7178V0Z",
    fill: "#FD7366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4282 59.9995C99.4282 71.0395 90.533 79.9995 79.573 79.9995C68.6129 79.9995 59.7178 71.0395 59.7178 59.9995C59.7178 48.9595 68.6129 39.9995 79.573 39.9995C90.533 39.9995 99.4282 48.9595 99.4282 59.9995Z",
    fill: "#2CBDFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2648_2425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 79.4366,
    height: 120,
    fill: "white",
    transform: "translate(20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathFigmaLog);
export default __webpack_public_path__ + "static/media/path-figma-log.c224b52dfc2b8d7015a756cf6017f057.svg";
export { ForwardRef as ReactComponent };